import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {ISearchData, ISearchQuery} from 'modules/search-popup/models';

export const searchPopupApiService = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getSearchSuggestions: builder.query<ISearchData, ISearchQuery | void>({
            query: (query) => {
                const trimmedQuery = query?.queryStr?.trim();
                const queryString = trimmedQuery ? `&query=${encodeURIComponent(trimmedQuery)}` : '';
                return {
                    url: `${API_VERSION}/search/suggestions?productsCount=3${queryString}`,
                };
            },
            transformResponse: (response: {data: ISearchData}) => response.data,
        }),
    }),
});

export const {useGetSearchSuggestionsQuery} = searchPopupApiService;

export const {getSearchSuggestions} = searchPopupApiService.endpoints;
